import { effects } from 'redux-saga'

import {
  logout,
  receiveCredentials,
} from '../../modules/authentication'

export default function* refreshSaga({ refreshHmac }) {
  const state = yield effects.select()
  const hmac = state.authentication.get('hmac')

  if (!hmac) {
    /* istanbul ignore next */
    // eslint-disable-next-line no-unused-expressions,no-console
    __DEBUG__ && console.log('Bailing - asked to refresh HMAC, but we dont have one to refresh.')
    return
  }

  try {
    const result = yield effects.call(refreshHmac, hmac)

    yield effects.put.resolve(receiveCredentials(undefined, result.hmac))
  } catch (e) {
    yield effects.put.resolve(logout())
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/authentication/refresh.js